import { ChildrenProps, Heading, If, makeClassName, Row } from "@hex-insights/core";
import { Tile } from "@s-i-s-i/see-learning.shared";
import { Main } from "../../../../Components";
import styles from "./styles.module.css";

const pageInfos = {
	index: {
		title: "Welcome",
		pageNo: 0,
	},
	"privacy-statement": {
		title: "Privacy",
		pageNo: 1,
	},
	profile: {
		title: "Your Profile",
		pageNo: 2,
	},
	"display-name": {
		title: "Display Name",
		pageNo: 3,
	},
	notifications: {
		title: "Notification Preferences",
		pageNo: 4,
	},
	success: {
		title: "Success",
		pageNo: 5,
	},
};

const totalPageProgress = 4;

export type OnboardingLayoutProps = {
	page: "index" | "privacy-statement" | "profile" | "display-name" | "notifications" | "success";
	footerContent?: React.ReactNode;
} & Partial<ChildrenProps>;

export function OnboardingLayout({ page, footerContent, children }: OnboardingLayoutProps) {
	const pageInfo = pageInfos[page];
	const hasHeader = page !== "index" && page !== "success";
	const hasFooter = !!footerContent;

	return (
		<Main className={styles["main"]}>
			<Tile
				className={makeClassName(
					styles["main-tile"],
					hasHeader ? styles["main-tile--with-header"] : "",
					hasFooter ? styles["main-tile--with-footer"] : "",
				)}
			>
				<If condition={hasHeader}>
					<Tile.Header className={styles["main-tile__header"]}>
						<Row justify="space-between" align="center" style={{ gap: "1rem" }}>
							<Heading.H1 className={styles["title"]} noMargin>
								{pageInfo.title}
							</Heading.H1>
							<span className={styles["page-progress"]}>
								{pageInfo.pageNo}/{totalPageProgress}
							</span>
						</Row>
					</Tile.Header>
				</If>
				<Tile.Body className={styles["main-tile__body"]}>{children}</Tile.Body>
				<If condition={hasFooter}>
					<Tile.Footer className={styles["main-tile__footer"]}>{footerContent}</Tile.Footer>
				</If>
			</Tile>
		</Main>
	);
}
